module.exports = __webpack_public_path__ + "static/img/qualifications_row_20.df5724b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_20.png
// module id = NcW5
// module chunks = 1